import React from 'react';
import { DefaultButton } from "@fluentui/react";
import { MessageType } from '../../api';
import AdaptiveForm from './AdaptiveForm';
import Suggestions from './Suggestions';

interface UserResponsesRender {
    styles: any;
    answer: any;
    onClick: Function;
    conversationId: string | undefined;
    submitFormResponse: Function;
}


const UserResponsesRender: React.FC<UserResponsesRender> = ({
    styles,
    answer,
    onClick,
    conversationId,
    ...restProps }) => {

    if (answer.messageType === MessageType.Options) {
        return (
            <>
                <div className={styles.chatMessageUserButtonContainer}>
                    {answer.messageInfo.options.map((option: any, index: number) => (
                        <DefaultButton
                            key={index}
                            className={styles.chatMessageUserButton}
                            onClick={() => onClick(option.value, conversationId, option.flowtype || answer.flowtype)}
                            text={option.label}
                        />
                    ))}
                </div>
            </>
        );

    } else if (answer.messageType === MessageType.ConsultationForm) {
        return (
            <AdaptiveForm {...restProps} />
        );
    }
    else {
        return (
            <>
                <div className={styles.chatMessageUser} tabIndex={0}>
                    <div className={styles.chatMessageUserMessage}>{answer.content}</div>
                </div>
            </>
        );
    }

};

export default UserResponsesRender;